import type { ImpactType } from '~/scopes/campaign/data/metals/types'

import { environmentalJourney } from './environmental'
import { geopoliticalJourney } from './geopolitical'
import { humanJourney } from './human'
import type { Journey, JourneyStop } from './types'

/** Partial on purpose: the entry row renders wherever `journeyFor` answers. */
const JOURNEYS: Partial<Record<ImpactType, Journey>> = {
  environmental: environmentalJourney,
  geopolitical: geopoliticalJourney,
  human: humanJourney,
}

export function journeyFor(impact: ImpactType | null): Journey | null {
  return impact ? (JOURNEYS[impact] ?? null) : null
}

/** The journey this metal is the subject of; three of the ~39 have one. */
export function journeyForMetal(slug: string): Journey | null {
  return (
    Object.values(JOURNEYS).find((journey) => journey.metal.slug === slug) ??
    null
  )
}

/** `step` is the 1-based index, not the URL's token. Out of range reads as `null`. */
export function stopAt(journey: Journey, step: number): JourneyStop | null {
  return journey.stops[step - 1] ?? null
}

/** The URL's `step`: every stop names itself, bookends included. */
export function stopToken(journey: Journey, step: number): string {
  return stopAt(journey, step)?.slug ?? journey.stops[0].slug
}

/** Its inverse; `null` is "not a stop of this journey", which the route repairs. */
export function stopFromToken(journey: Journey, token: string): number | null {
  const index = journey.stops.findIndex((stop) => stop.slug === token)

  return index === -1 ? null : index + 1
}
